export interface WorktableInfo {
  id: number;
  name: string;
}

export interface WorktableStats {
  okCount: number;
  notOkCount: number;
  totalCount: number;
}

export interface WorktableProduct {
  id: number;
  name: string;
  sequence: number | null;
  status: string;
  image?: string | null;
}

export interface WorktableScanResponse {
  code: string;
  scanType: "PRODUCT" | "BAG";
  isValid: boolean;
  message?: string;
  worktable: WorktableInfo;
  orderBag: { id: string; sequence: number | null } | null;
  order: { id: string; friendlyId: string } | null;
  products: WorktableProduct[];
  stats: WorktableStats;
}

export interface WorktableCompleteResponse {
  code: string;
  isValid: boolean;
  message?: string;
  worktable: WorktableInfo;
  order: { id: string; friendlyId: string; status: string };
  products: WorktableProduct[];
  stats: WorktableStats;
}

export type WorktableOutcome = "OK" | "NOT_OK";

// Content of the on-screen GOED / NIET GOED action QR codes.
// These are plain strings (no numeric label pattern), so they are routed
// to the worktable page instead of being treated as entity barcodes.
export const WORKTABLE_ACTION_OK = "WT-GOED";
export const WORKTABLE_ACTION_NOT_OK = "WT-NIET-GOED";
